import { render, staticRenderFns } from "./ConsentBot.vue?vue&type=template&id=f4e77a30&scoped=true&lang=html&"
import script from "./ConsentBot.vue?vue&type=script&lang=js&"
export * from "./ConsentBot.vue?vue&type=script&lang=js&"
import style0 from "./ConsentBot.vue?vue&type=style&index=0&id=f4e77a30&prod&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f4e77a30",
  null
  
)

export default component.exports